import { Alert, Tag } from "antd";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

import type { HelpDone } from "./chatTypes";

export function HelpAnswer({ text, done, streaming }: { text: string; done?: HelpDone; streaming: boolean }) {
  const pieces = text.split(/(\[\[ref:[^]\n]+\]\])/g);
  return <div className="help-answer" data-testid="help-answer">
    {pieces.map((piece, i) => {
      const ref = /^\[\[ref:([^]\n]+)\]\]$/.exec(piece);
      if (!ref) return <ReactMarkdown key={i} skipHtml
        allowedElements={["p", "ol", "ul", "li", "strong", "em", "code", "pre", "br"]} unwrapDisallowed>{piece}</ReactMarkdown>;
      const citation = done?.citations.find((c) => c.id === ref[1]);
      return citation ? <Tag key={i}><Link to={`/manual/${citation.module}#${encodeURIComponent(citation.anchor)}`}>{citation.title}</Link></Tag> :
        done ? null : <Tag key={i} color="default">参照確認中</Tag>;
    })}
    {streaming && <span aria-label="生成中">▍</span>}
    {done?.stop === "refusal" && <Alert type="info" message="この質問には回答できませんでした。言い換えてお試しください" />}
    {done?.stop === "max_tokens" && <small>(長くなったため途中までです)</small>}
    {done?.not_covered && <Alert type="info" message="マニュアルに記載がありません" />}
    {done && !done.not_covered && !done.citations.length && <small>根拠の節を示せませんでした。内容をマニュアルで確かめてください</small>}
    {!!done?.citations.length && <div>参照した節: {done.citations.map((c) => <Tag key={c.id}>
      <Link to={`/manual/${c.module}#${encodeURIComponent(c.anchor)}`}>{c.title}</Link></Tag>)}</div>}
  </div>;
}
